module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-10\">\r\n        <select name=\"dateFormat\" id=\"dateFormat\" >\r\n            <option value=\"MM/DD/YYYY\">MM/DD/YYYY</option>\r\n            <option value=\"DD/MM/YYYY\">DD/MM/YYYY</option>\r\n            <option value=\"MM.DD.YYYY\">MM.DD.YYYY</option>\r\n            <option value=\"DD.MM.YYYY\">DD.MM.YYYY</option>\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}